<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" appendTo="body"
          [style]="{'width': '960px', 'height': '800px'}">

    <p-header>
        <span>Network Transfer Options</span>
    </p-header>

    <div style="overflow: scroll;">
        <p>Network [{{networkName}}]&apos;s agents are registered with the following API keys. 
            Select any API keys that should also be transferred to user [{{targetUsername}}].</p>
    
        <p-table class="api-keys-table" [value]="networkAgents" [rows]="12" [scrollable]="true" scrollHeight="500px"
                 dataKey="AgentGuid" selectionMode="multiple" [(selection)]="selectedNetworkAgents" 
                 [resizableColumns]="true">

            <ng-template pTemplate="header">
                <tr>
                    <th class="uv-table-checkbox"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                    <th pResizableColumn [pSortableColumn]="AgentName">
                        Agent Name
                        <p-sortIcon [field]="AgentName"></p-sortIcon>
                    </th>
                    <th pResizableColumn [pSortableColumn]="ClientAgentApiKeyName">
                        API Key Name
                        <p-sortIcon [field]="ClientAgentApiKeyName"></p-sortIcon>
                    </th>
                    <th pResizableColumn [pSortableColumn]="ClientAgentApiKey">
                        API Key
                        <p-sortIcon [field]="ClientAgentApiKey"></p-sortIcon>
                    </th>
                    <th pResizableColumn [pSortableColumn]="ClientAgentApiKeyUsername">
                        API Key Owner
                        <p-sortIcon [field]="ClientAgentApiKeyUsername"></p-sortIcon>
                    </th>
               </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
                <tr>
                    <td class="uv-table-checkbox">
                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td>
                        <span class="uv-table-value">{{ rowData.AgentName }}</span>
                    </td>
                    <td>
                        <span class="uv-table-value">{{ rowData.ClientAgentApiKeyName }}</span>
                    </td>
                    <td>
                        <span class="uv-table-value">{{ rowData.ClientAgentApiKey }}</span>
                    </td>
                    <td>
                        <span class="uv-table-value">{{ rowData.ClientAgentApiKeyUsername }}</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <p-footer>
        <button type="button" pButton icon="fa fa-check" [disabled]="false" (click)="onOkClicked()" label="OK"></button>
        <button type="button" pButton icon="fa fa-close" [disabled]="false" (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

</p-dialog>
